import React, { useEffect, useState } from "react";
import PostVideo from "./common/PostVideo";
import { useParams, useNavigate, useLocation } from "react-router-dom";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const PostDetailPage = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    console.log("token in PostDetailpage:", token);
    if (!token) {
      navigate("/login", { state: { from: location }, replace: true });
      return;
    }

    const fetchPostById = async (postId) => {
          const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");

      try {
        const response = await fetch(`${API_BASE_URL}/post/get-post-by-id?id=${postId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        });
        const data = await response.json();
        if (data.success && data.result) {
          setPost(data.result);
        } else {
          setPost(null);
          alert("Failed to fetch post details.");
        }
      } catch (error) {
        setPost(null);
        alert("Error fetching post details.");
      }
    };

    fetchPostById(id);
  }, [id, navigate, location]);

  if (!sessionStorage.getItem("accessToken") && !localStorage.getItem("accessToken")) {
    return null;
  }

  if (!post) return <div>Loading post...</div>;

  return (
    <div className="max-w-2xl mx-auto mt-10 bg-white p-4 shadow-md rounded-lg">
      <div className="flex items-center mb-4">
        <img
          src={post.user?.profile_picture_url || require("../assets/profile.png")}
          alt={post.user?.username}
          className="w-12 h-12 rounded-full mr-3"
        />
        <div>
          <p className="font-semibold">{post.user?.first_name} {post.user?.last_name}</p>
          <p className="text-sm text-gray-500">@{post.user?.username}</p>
        </div>
      </div>
      <p className="text-xs text-gray-400 mb-2">
        {post.created_at ? new Date(post.created_at).toLocaleString() : ""}
      </p>
      {/* <h2 className="text-xl font-bold mb-2">{post.title || "Untitled Post"}</h2> */}
      <p className="mt-2 text-gray-700">{post.content}</p>
      {/* Media */}
      {post.media_url && post.media_url.length > 0 && (
        <div className="mt-4 flex gap-2">
          {post.media_url.map((media, idx) =>
            media.media_type === "video" ? (
              <PostVideo key={idx} src={media.url} soundId={post.sound_id} postId={post.id} silenced={post.rights_enforcement === "mute"} licenceNeeded={post?.licence_needed} className="w-40 h-40 rounded" />
            ) : (
              <img key={idx} src={media.url} alt={`media-${idx}`} className="w-40 h-40 rounded object-cover" />
            )
          )}
        </div>
      )}
      {/* Stats */}
      <div className="mt-4 flex gap-6 text-sm text-gray-600">
        <span>Likes: {post.likeCount}</span>
        <span>Comments: {post.commentCount}</span>
        <span>Contributors: {post.donatorCount}</span>
      </div>
    </div>
  );
};

export default PostDetailPage;